import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-accentDark text-white w-full h-12 fixed bottom-0 left-0 z-50">
      <Link
        to="/donations"
        className="flex flex-row h-full text-center justify-center">
        <span className="flex flex-col text-center justify-center text-white no-underline transition-colors hover:text-darkColor hover:underline">
          ¿Te gusta ManaValue? Ayudanos donando una tierra básica
        </span>
      </Link>
    </footer>
  );
};

export default Footer;
